/* unplugin-vue-components disabled */import script from "./BeiDanView.vue?vue&type=script&setup=true&lang=js"
export * from "./BeiDanView.vue?vue&type=script&setup=true&lang=js"

import "./BeiDanView.vue?vue&type=style&index=0&id=c73ad6f4&step=true&lang=css"

const __exports__ = script;

export default __exports__